import { Component, OnInit,EventEmitter,Input,Output } from '@angular/core';
import { Calibration_List_Interface, Empty_Calibration_List_Interface } from 'src/app/Interface/Calibration_List_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationEvaluateService } from 'src/app/Service/Calibration/CalibrationEvaluate.service';

@Component({
  selector: 'app-CalibrationEvaluateLetterForm',
  templateUrl: './CalibrationEvaluateLetterForm.component.html',
  styleUrls: ['./CalibrationEvaluateLetterForm.component.scss']
})
export class CalibrationEvaluateLetterFormComponent implements OnInit {

  @Input() inner_Calibration: Calibration_List_Interface = Empty_Calibration_List_Interface()
  @Output() OnBack_Calibration_Action = new EventEmitter<number>();
  InProccessing: boolean = false
  modalRef_Delete: any;
  page:any

  DataList_Evaluate: Array<General_Interface> = []
  Data_Seleted_Delete: General_Interface = Empty_General_Interface()

  constructor(
    private CalibrationEvaluate_Service: CalibrationEvaluateService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.ReadData_Evaluate()
  }

  ReadData_Evaluate() {
    this.InProccessing = true
    this.CalibrationEvaluate_Service.GetActiveList(Number(this.inner_Calibration.letterRequestSchduleCustomer_id)
    ).subscribe(
      data => {
        this.DataList_Evaluate = data
        this.InProccessing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  OnSet_Back_CalibrationList(){
    this.OnBack_Calibration_Action.emit(-1);
  }

  OnSubmit()
  {
    var Indexer: number = -1
    for (let item of this.DataList_Evaluate)
    {
      if (item.dsc == "0")
      {
        Indexer=this.DataList_Evaluate.indexOf(item)
        break;
      }

    }

    if (Indexer > -1) {
      this.Alertify_Service.ErrorMessage("سوال ردیف "+ (Indexer+1) +" را پاسخ دهید")
    }
    else {
      this.InProccessing=true
      this.CalibrationEvaluate_Service.SubmitEvalute(this.DataList_Evaluate, Number(this.inner_Calibration.letterRequestSchduleCustomer_id)).subscribe(
        data => {
          this.InProccessing=false
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }

      )
    }

  }

}
